const Landing = () =>
  import(/* webpackChunkName: "cms-landing" */ '@/pages/cms/content/landing/index.vue')
const CreateLanding = () =>
  import(
    /* webpackChunkName: "cms-landing" */ '@/pages/cms/content/landing/create.vue'
  )
const EditLanding = () =>
  import(/* webpackChunkName: "cms-landing" */ '@/pages/cms/content/landing/edit.vue')


export default {
  path: 'landing',
  meta: {
    label: 'landingPage',
    auth: 'landing'
  },
  component: {
    name: 'Landing',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CmsLandingReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Landing
    },
    {
      name: 'CmsCreateLanding',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateLanding
    },
    {
      name: 'CmsEditLanding',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditLanding,
      props: true
    }
  ]
}
